import Headline from '@common/components/headline/Headline';
import IsRenderResult from '@common/components/IsRenderResult/IsRenderResult';
import { Seo } from '@common/components/SEO/SEO';
import { useGetSuperExactScoreQuery } from '@features/super-exact-score/api/superExactScoreApi';
import Box from '@mui/material/Box';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import SuperExactScoreResults from './components/SuperExactScoreResults';
import './superExactScore.scss';

const SuperExactScore = () => {
  const { data, isFetching, isError, isLoading, isSuccess, refetch } = useGetSuperExactScoreQuery();

  return (
    <Box>
      <Seo
        title="Супер точный счет"
        description="Супер точный счет"
      />
      <Headline title={<FormattedMessage id="SUPER_EXACTSCORE"/>}/>
      <IsRenderResult
        isLoading={isLoading}
        isFetching={isFetching}
        isSuccess={isSuccess}
        isError={isError}
        data={data}
        onRetry={refetch}
      >
        {data && (
           <>
             <SuperExactScoreResults  exactScore={data?.exactScore} exactScoreBets={data?.exactScoreBets}/>
           </>
        )}
      </IsRenderResult>
    </Box>
  );
};

export default SuperExactScore;
